import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialHierarchyFiles: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.57 0v1.52h-1.52v1.53h-1.53v4.57h-3.04v1.52h3.04v4.57h10.67V0Zm6.1 12.19h-7.62V4.57h3.04V1.52h4.58Zm-6.1 6.1v1.52h-1.52v1.52h-1.53v4.57h-3.04v1.53h3.04V32h10.67V18.29Zm6.1 12.19h-7.62v-7.62h3.04v-3.05h4.58Z\"/><path fill=\"currentColor\" d=\"M23.62 24.38h1.52v1.52h-1.52Zm0-18.29h1.52v1.53h-1.52Zm-3.05 21.34h4.57v1.52h-4.57Zm0-18.29h4.57v1.53h-4.57Zm0 15.24h1.52v1.52h-1.52Zm0-18.29h1.52v1.53h-1.52ZM9.9 25.9h3.05v1.53H9.9Zm0-18.28h3.05v1.52H9.9ZM5.33 25.9h3.05v1.53H5.33Zm0-19.81H3.81v4.58h1.52V9.14h3.05V7.62H5.33zM3.81 24.38h1.52v1.52H3.81Zm0-6.09h1.52v4.57H3.81Zm0-6.1h1.52v4.57H3.81ZM3.81 0h1.52v4.57H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialHierarchyFiles
